import React, { createContext, useEffect } from "react";
import { InstanceData } from "../models/shared/InstanceData";
import { getInstanceData } from "../utils/api";
import { signInWithCustomToken } from "firebase/auth";
import { useAuth } from "reactfire";

interface InstanceContext {
    instanceData: Partial<InstanceData>
    instanceId: string,
    loaded: boolean,
    onTrial: boolean,
    trialEnded: boolean,
    daysLeft: number
}

const DEFAULT_INSTANCE = {
    instanceData: {},
    instanceId: '',
    loaded: false,
    onTrial: false,
    trialEnded: false,
    daysLeft: 0,
}

const instanceContext = createContext<InstanceContext>(DEFAULT_INSTANCE)

export const useInstanceContext = () => React.useContext(instanceContext);

interface Props {
    children: React.ReactNode
}

export const InstaceContextProvider = (props: Props) => {
    const [state, setState] = React.useState<InstanceContext>(DEFAULT_INSTANCE);
    const auth = useAuth();

    useEffect(() => {
        getInstanceData().then(response => {
            signInWithCustomToken(auth, response.token);

            const instanceData = response.instanceData;
            const onTrial = !instanceData.planId;
            const daysLeft = getRemainingTrialDays(instanceData.trialEndsAt || new Date());
            const trialEnded = daysLeft < 1;

            setState({
                instanceData: response.instanceData,
                instanceId: response.instanceData?.instanceId || '',
                loaded: true,
                onTrial,
                daysLeft,
                trialEnded
            })
        });
    }, [auth])

    return <instanceContext.Provider value={state}>{props.children}</instanceContext.Provider>
}

const getRemainingTrialDays = (trialEndsAt: Date): number => {
    const now = new Date();
    const diff = trialEndsAt.getTime() - now.getTime();
    return Math.ceil(diff / (1000 * 3600 * 24));
}

